import { AppState } from '../app-state';

export const getError = (state: AppState) => state.error;

export const getLoadProgress = (state: AppState) => state.loadProgress;

export const getStonks = (state: AppState) => state.stonks;

export const getUser = (state: AppState) => state.user;
